import projectTagsSettingsComponent from './project-tags-settings.component';

const projectTagsSettingsModule = angular.module('projectTagsSettings', [])
  .component('projectTagsSettings', projectTagsSettingsComponent)
  .name;

export default projectTagsSettingsModule;
